import React, { Component, Fragment } from 'react'
import cx from 'classnames'
import actions from 'redux/actions'
import { links } from 'common/helpers'
import { connect } from 'redaction'
import { FormattedMessage } from 'sb-react-intl'

import Countdown from 'components/ui/countdown/ActiveQueueCountdown/ActiveQueueCountdown'
import Href from 'components/_new/ui/Href/Href'

import messages from './messages'
import s from './CountdownBanner.scss'


class CountdownBanner extends Component {

  handleClick = () => {
    const { pathname } = this.props

    const isThankYouPage = /thankyou/.test(pathname)

    if (isThankYouPage) {
      actions.models.router.push(links.subscription.root)
    }
  }

  render() {
    const { pathname } = this.props

    const isPointer = /thankyou/.test(pathname)

    const rootClassName = cx(s.countdown, {
      [s.pointer]: isPointer,
    })

    const content = (
      <Fragment>
        <FormattedMessage className={s.text} {...messages.text} />
        <Countdown className={s.digits} />
      </Fragment>
    )

    if (isPointer) {
      return (
        <Href className={rootClassName} onClick={this.handleClick}>
          {content}
        </Href>
      )
    }

    return (
      <div className={rootClassName} role="complementary">
        {content}
      </div>
    )
  }
}


export default connect({
  pathname: 'routing.location.pathname',
})(CountdownBanner)
